<button
  size="tiny"
  status="danger"
  nbButton
  ghost
  (click)="canDelete ? deleteBoard() : prepareForDelete()"
>
  <nb-icon icon="trash-2-outline" status="danger"></nb-icon>
  <span *ngIf="!canDelete">{{ label }}</span>
  <span *ngIf="canDelete">Confirm</span>
</button>
<button
  *ngIf="canDelete"
  size="tiny"
  status="basic"
  nbButton
  ghost
  class="delete-button__cancel"
  (click)="cancel()"
>
  Cancel
</button>
